/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_file_docrepo_upload_post } from '../models/Body_upload_file_docrepo_upload_post';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FileUploadService {
    /**
     * Upload File
     * @param collectionType
     * @param collectionRef
     * @param repoType
     * @param formData
     * @param uploadMode
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadFileDocrepoUploadPost(
        collectionType: string,
        collectionRef: string,
        repoType: string,
        formData: Body_upload_file_docrepo_upload_post,
        uploadMode: string = 'final',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/docrepo/upload',
            query: {
                'collection_type': collectionType,
                'collection_ref': collectionRef,
                'repo_type': repoType,
                'upload_mode': uploadMode,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get File
     * @param collectionType
     * @param collectionRef
     * @param repoType
     * @param filename
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFileDocrepoViewCollectionTypeCollectionRefRepoTypeFilenameGet(
        collectionType: string,
        collectionRef: string,
        repoType: string,
        filename: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docrepo/view/{collection_type}/{collection_ref}/{repo_type}/{filename}',
            path: {
                'collection_type': collectionType,
                'collection_ref': collectionRef,
                'repo_type': repoType,
                'filename': filename,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete File
     * @param fileUrl
     * @param collectionType
     * @param collectionRef
     * @param repoType
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteFileDocrepoDeleteDelete(
        fileUrl: string,
        collectionType: string,
        collectionRef: string,
        repoType: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/docrepo/delete',
            query: {
                'file_url': fileUrl,
                'collection_type': collectionType,
                'collection_ref': collectionRef,
                'repo_type': repoType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Move Temp Files
     * @param collectionType
     * @param newRef
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static moveTempFilesDocrepoMoveTempFilesPost(
        collectionType: string,
        newRef: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/docrepo/move-temp-files',
            query: {
                'collection_type': collectionType,
                'new_ref': newRef,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
